import React from 'react';

import sqlTemplatesPositions from '../../post-positions/sql-templates';
import ROUTES from '../../routes';

import Container from '@components/Container';
import CTA from '@components/CTA';
import CustomHead from '@components/CustomHead';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import { SectionHeading } from '@components/landing/sectionComponents';
import LinkList from '@components/LinkList';

const Home = ({ data }) => {
  const {
    product: productLinks,
    engineering: engineeringLinks,
    support: supportLinks,
    sales: salesLinks,
    marketing: marketingLinks,
    analytics: analyticsLinks,
  } = JSON.parse(data);

  return (
    <>
      <CustomHead
        meta={{
          title: 'SQL Templates | PopSQL',
          image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/og/sql-templates.jpg`, // TODO get OG from figma
        }}
      />
      <main>
        <Header />
        <SectionHeading
          text="SQL Templates"
          moreStyles={{ marginTop: '64px' }}
        />
        <Container singleColumn className="mt-16 mb-8">
          <p className="text-center">
            From startups to enterprises, SQL is more powerful when used across
            teams. Here are foundational templates we've battle-tested at
            PopSQL. Try them in our{' '}
            <a href="/sql-templates/analytics/exploring-sample-dataset">
              sample DB
            </a>
            .
          </p>
          <div className="h-8" />
          <LinkList
            title="Product"
            items={productLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
          <LinkList
            title="Engineering"
            items={engineeringLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
          <LinkList
            title="Support"
            items={supportLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
          <LinkList
            title="Sales"
            items={salesLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
          <LinkList
            title="Marketing"
            items={marketingLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
          <LinkList
            title="Analytics"
            items={analyticsLinks}
            containerClasses="md:grid-cols-2 gap-4"
            hasBorder
          />
          <div className="h-8" />
        </Container>
        <CTA />
      </main>
      <Footer />
    </>
  );
};

export async function getStaticProps() {
  const matter = require('gray-matter');
  const removeMarkdownTitles = /#(\S)/g;

  const data = ((context) => {
    const keys = context.keys();
    const values = keys.map(context);
    const innerData = {
      product: [],
      engineering: [],
      support: [],
      sales: [],
      marketing: [],
      analytics: [],
    };
    keys.forEach((key, index) => {
      // Create id from filename
      const id = key.split('/')[1];
      const value = values[index];

      // Parse yaml metadata & markdownbody in document.
      const document = matter(value.default);

      // If isDraft
      if (document.data.draft === undefined ? true : document.data.draft)
        return;

      // Create slug from filename
      const slug = key
        .replace(/^.*[\\/]/, '')
        .split('.')
        .slice(0, -1)
        .join('.');

      const post = {
        asPath: ROUTES.sqlTemplatesPost(id, slug).asPath,
        href: ROUTES.sqlTemplatesPost().href,
        title: document.data.title,
        icon: document.data.icon || false,
        subtitle:
          document.data.subtitle ||
          document.content
            .replace(removeMarkdownTitles, '')
            .split(' ')
            .slice(0, 10)
            .join(' ') + '...',
        isDraft: document.data.draft === undefined ? true : document.data.draft,
        position: sqlTemplatesPositions.indexOf(slug),
      };

      innerData[id].push(post);
    });
    const sortedInnerData = {};
    Object.keys(innerData).forEach((key) => {
      sortedInnerData[key] = innerData[key].sort((a, b) =>
        a.position < b.position ? -1 : 1,
      );
    });
    return sortedInnerData;
  })(require.context(`../../data/sql-templates`, true, /\.md$/));

  return { props: { data: JSON.stringify(data) } };
}

export default Home;
